import * as React from "react";
import { ICustomerRow } from "../IUserConfig";
import "./SideLogo.scss";

export const SideLogo = ({ props }: { props: ICustomerRow }): JSX.Element => (
    <div className="side-logo-container">
        <div className="side-logo">
            <a href={props.sideLogoLink} target="_new">
                <img src={props.sideLogo} />
            </a>
        </div>
    </div>
);
